import { Box, useTheme, styled } from '@mui/material';
import React from 'react';

import Typography from '../Typography/Typography';
import TabBody from './TabBody';
import { VerticalTabBarProps } from './types';

function VerticalTabBar({
  tabs,
  tabIndex,
  setTabIndex,
  tabBodyWidth,
  menuWidth,
  menuColor,
  titleEndAdornment,
  divideAfterIndex,
}: VerticalTabBarProps) {
  const { palette } = useTheme();

  return (
    <Box display='flex' height='100%'>
      {typeof tabIndex === 'number' && (
        <TabBody
          title={tabs[tabIndex].title}
          titleEndAdornment={titleEndAdornment}
          tabBodyWidth={tabBodyWidth}
          isFullWidth={tabs[tabIndex].isFullWidth}
        >
          {tabs[tabIndex].component}
        </TabBody>
      )}
      <Tabs menuWidth={menuWidth} menuColor={menuColor}>
        {tabs.map((tab, index) => {
          const { Icon, label } = tab;
          const isActive = index === tabIndex;
          const shouldShowDivider = divideAfterIndex === index;

          return (
            <React.Fragment key={label}>
              <TabItem onClick={() => setTabIndex(index)}>
                <Button>
                  <Box
                    bgcolor={
                      isActive ? palette.colors.purple[100] : 'transparent'
                    }
                    borderRadius='4px'
                    display='flex'
                    padding='8px'
                  >
                    <Icon
                      color={
                        isActive
                          ? palette.colors.purple[500]
                          : palette.colors.grey[700]
                      }
                      size={24}
                    />
                  </Box>
                  <Typography color={palette.colors.grey[700]} variant='font11'>
                    {label}
                  </Typography>
                </Button>
              </TabItem>
              {shouldShowDivider && <Divider />}
            </React.Fragment>
          );
        })}
      </Tabs>
    </Box>
  );
}

const Tabs = styled('ul', {
  shouldForwardProp: propName =>
    propName !== 'menuWidth' && propName !== 'menuColor',
})<{ menuWidth?: number; menuColor?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 20px 0;
  ${props => props.menuWidth && `width: ${props.menuWidth}px;`}
  overflow-y: auto;
  background-color: ${props => props.menuColor};
`;

const Divider = styled('div')`
  width: 75%;
  height: 0px;
  border: 1px solid ${props => props.theme.palette.colors.slate[200]};
`;

const TabItem = styled('li')``;

const Button = styled('button')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  padding: 4px 12px;
  background-color: ${props => props.theme.palette.colors.white};
  border-width: 0;
`;

export default VerticalTabBar;
